import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import {
  ACTIONS,
  CentralApis,
  Endpoint,
  PageConfig,
} from '../interfaces/internal';

import { Result } from '../interfaces/helpers';
import { PageTitles } from '../interfaces/types';
import { Page } from './page';
import { FsaAssignment } from '../models/fsaAssignment.model';

export class FsaAssignmentPage extends Page<FsaAssignment> {
  constructor({ endpoint }: Endpoint, config: PageConfig) {
    super(
      (endpoint as CentralApis).activity + 'fsa',
      PageTitles.fsaAssignment,
      config
    );

    this.initializeColumns({
      keys: new FsaAssignment(),
      editableFields: this.editableFields,
      hiddenFormFields: [],
      hiddenTableFields: [],
    });
  }

  get actions(): string[] {
    return [ACTIONS.delete];
  }

  get editableFields(): string[] {
    return [];
  }

  fetch(queryParams?): Observable<Result<FsaAssignment>> {
    return this.getItems(queryParams).pipe(
      take(1),
      // @ts-ignore
      switchMap((res) => map)
    );
  }

  update(item: FsaAssignment): Observable<FsaAssignment> {
    throw new Error('Method not implemented.');
  }
  fetchById(id: string, condition?: any): Observable<FsaAssignment> {
    throw new Error('Method not implemented.');
  }
  createFromDTO(item: any): FsaAssignment {
    return item;
  }
}
